const pageBuilderApi = (widgetUuid: string, props: object): void => {
    if (window.BigCommerce && window.BigCommerce.sendWidgetUpdate) {
        window.BigCommerce.sendWidgetUpdate(props, widgetUuid);
    }
};

export default pageBuilderApi;
